// JsFromRoutes CacheKey 70662f4e6e09c62d2042a14ad26d9693
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  currentBenefits: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/:prospect_id/quotes/:quote_id/current_benefits'),
  strategy: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/:prospect_id/quotes/:quote_id/strategy'),
  benchmarkSuggestions: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/:prospect_id/quotes/:quote_id/benchmark_suggestions'),
  flatAllowances: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/:prospect_id/quotes/:quote_id/flat_allowances'),
  new: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/:prospect_id/quotes/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/:prospect_id/quotes/:id/edit'),
}
